import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InstallationService {

  private _beforeInstallPromptEvent: any;

  public get canInstall(): boolean {
    return typeof this._beforeInstallPromptEvent?.prompt === 'function';
  }

  public initialize(beforeInstallPromptEvent: any): void {
    this._beforeInstallPromptEvent = beforeInstallPromptEvent;
  }

  public async installPwa(): Promise<boolean> {
    const result: any = await this._beforeInstallPromptEvent.prompt();
    const installed: boolean = !(result?.outcome === 'dismissed');

    if (installed) {
      this._beforeInstallPromptEvent = null;
    }

    return installed;
  }

}
